import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyBG2psAjgujf-ChoPvUJ7UPshLr2-UZl4g',
  appId: '1:425313285849:web:e0ff12f0ca7fc5dee130c8',
  messagingSenderId: '425313285849',
  projectId: 'taskcombat-b1fa6',
  authDomain: 'taskcombat-b1fa6.firebaseapp.com',
  storageBucket: 'taskcombat-b1fa6.firebasestorage.app',
};

export const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
